import { InterceptorClient } from "../../interceptor/interceptorClient";
import { ratingsEndPoint, testimonialsEndPoint } from "./constant";

/**
 * Fetches the remaining time for product delivery from the API.
 *
 * This asynchronous function sends a request to the API endpoint returned by `getProductDeliveryTimeLeft()`
 * and retrieves the remaining delivery time for a product.
 *
 * @async
 * @function
 * @returns {Promise<Object>} A promise that resolves to the JSON response from the API, containing the delivery time left.
 * @throws {Error} Will throw an error if the fetch request fails.
 */
export const getTestimonialsData = async (options) => {
  return await InterceptorClient.getFNTSInstance(process.env.NEXT_PUBLIC_R2_CLIENT_API_GATEWAY).get(
    `${testimonialsEndPoint(options)}`,
  );
};

/**
 * Fetches the remaining time for product delivery from the API.
 *
 * This asynchronous function sends a request to the API endpoint returned by `getProductDeliveryTimeLeft()`
 * and retrieves the remaining delivery time for a product.
 *
 * @async
 * @function
 * @returns {Promise<Object>} A promise that resolves to the JSON response from the API, containing the delivery time left.
 * @throws {Error} Will throw an error if the fetch request fails.
 */
export const getRatingsData = async (options) => {
  return await InterceptorClient.getFNTSInstance(process.env.NEXT_PUBLIC_R2_CLIENT_API_GATEWAY).get(
    `${ratingsEndPoint(options)}`,
  );
};
